import {
  // Jobs List CRUD Action Types
  GET_JOBS_DATA,
  GET_JOBS_DATA_SUCCESS,
  GET_JOBS_DATA_FAIL,
  ADD_NEW_JOB,
  ADD_JOB_SUCCESS,
  ADD_JOB_FAIL,
  DELETE_JOB,
  DELETE_JOB_SUCCESS,
  DELETE_JOB_FAIL,
  UPDATE_JOB,
  UPDATE_JOB_SUCCESS,
  UPDATE_JOB_FAIL,
  // Jobs Status Action Types
  GET_JOB_STATUS_DATA,
  GET_JOB_STATUS_DATA_SUCCESS,
  GET_JOB_STATUS_DATA_FAIL,
  ADD_NEW_JOB_STATUS,
  ADD_JOB_STATUS_SUCCESS,
  ADD_JOB_STATUS_FAIL,
  DELETE_JOB_STATUS,
  DELETE_JOB_STATUS_SUCCESS,
  DELETE_JOB_STATUS_FAIL,
  UPDATE_JOB_STATUS,
  UPDATE_JOB_STATUS_SUCCESS,
  UPDATE_JOB_STATUS_FAIL,
  GET_JOBS_PDF_DATA,
  GET_JOBS_PDF_DATA_SUCCESS,
  GET_JOBS_PDF_DATA_FAIL,
  GET_JOBS_TYPE_DATA,
  GET_JOBS_TYPE_DATA_SUCCESS,
  GET_JOBS_TYPE_DATA_FAIL,
  GET_JOBS_PRIORITY_DATA,
  GET_JOBS_PRIORITY_DATA_SUCCESS,
  GET_JOBS_PRIORITY_DATA_FAIL,
  GET_SINGLE_CUSTOMER_JOBS_LIST_DATA,
  GET_SINGLE_CUSTOMER_JOBS_LIST_DATA_SUCCESS,
  GET_SINGLE_CUSTOMER_JOBS_LIST_DATA_FAIL,
  GET_UNINVOICED_JOBS_LIST_DATA,
  GET_UNINVOICED_JOBS_LIST_DATA_SUCCESS,
  GET_UNINVOICED_JOBS_LIST_DATA_FAIL,
  CONVERT_JOB_TO_INVOICE,
  CONVERT_JOB_TO_INVOICE_SUCCESS,
  CONVERT_JOB_TO_INVOICE_FAIL,
  GET_RECURRING_JOBS_LIST_DATA,
  GET_RECURRING_JOBS_LIST_DATA_SUCCESS,
  GET_RECURRING_JOBS_LIST_DATA_FAIL,
  CREATE_RECURRING_JOB,
  CREATE_RECURRING_JOB_SUCCESS,
  CREATE_RECURRING_JOB_FAIL,
  GET_RECURRING_JOB_DETAILS,
  GET_RECURRING_JOB_DETAILS_SUCCESS,
  GET_RECURRING_JOB_DETAILS_FAIL,
  UPDATE_RECURRING_JOB,
  UPDATE_RECURRING_JOB_SUCCESS,
  UPDATE_RECURRING_JOB_FAIL,
  UPLOAD_JOB_FILES,
  UPLOAD_JOB_FILES_SUCCESS,
  UPLOAD_JOB_FILES_FAIL,
  SEARCH_SINGLE_JOB_FILES_LIST,
  SEARCH_SINGLE_JOB_FILES_LIST_SUCCESS,
  SEARCH_SINGLE_JOB_FILES_LIST_FAIL,
  ADD_JOB_TYPE,
  ADD_JOB_TYPE_SUCCESS,
  ADD_JOB_TYPE_FAIL,
  DELETE_JOB_TYPE,
  DELETE_JOB_TYPE_SUCCESS,
  DELETE_JOB_TYPE_FAIL,
  UPDATE_JOB_TYPE,
  UPDATE_JOB_TYPE_SUCCESS,
  UPDATE_JOB_TYPE_FAIL,
  ADD_JOB_PRIORITY,
  ADD_JOB_PRIORITY_SUCCESS,
  ADD_JOB_PRIORITY_FAIL,
  DELETE_JOB_PRIORITY,
  DELETE_JOB_PRIORITY_SUCCESS,
  DELETE_JOB_PRIORITY_FAIL,
  UPDATE_JOB_PRIORITY,
  UPDATE_JOB_PRIORITY_SUCCESS,
  UPDATE_JOB_PRIORITY_FAIL,
  DELETE_SINGLE_JOB_FILE,
  DELETE_SINGLE_JOB_FILE_SUCCESS,
  DELETE_SINGLE_JOB_FILE_FAIL,
  UPDATE_FILE_ATTACHMENT,
  UPDATE_FILE_ATTACHMENT_SUCCESS,
  UPDATE_FILE_ATTACHMENT_FAIL,
  GET_JOB_SEARCH_LIST_DATA,
  GET_JOB_SEARCH_LIST_DATA_SUCCESS,
  GET_JOB_SEARCH_LIST_DATA_FAIL,
  GET_JOBS_OPEN_LIST_DATA,
  GET_JOBS_OPEN_LIST_DATA_SUCCESS,
  GET_JOBS_OPEN_LIST_DATA_FAIL,
  GET_READY_TO_INVOICE_JOBS_LIST_DATA,
  GET_READY_TO_INVOICE_JOBS_LIST_DATA_SUCCESS,
  GET_READY_TO_INVOICE_JOBS_LIST_DATA_FAIL,
  MARK_JOB_AS_COMPLETED,
  MARK_JOB_AS_COMPLETED_SUCCESS,
  MARK_JOB_AS_COMPLETED_FAIL,
  CONVERT_JOB_TO_PROFORMA_INVOICE,
  CONVERT_JOB_TO_PROFORMA_INVOICE_SUCCESS,
  CONVERT_JOB_TO_PROFORMA_INVOICE_FAIL,
  GET_INVOICES_BY_JOB,
  GET_INVOICES_BY_JOB_SUCCESS,
  GET_INVOICES_BY_JOB_FAIL,
  PREDICTED_MARK_BILLED,
  PREDICTED_MARK_BILLED_SUCCESS,
  PREDICTED_MARK_BILLED_FAIL,
  PREDICTED_LINK_TO_INVOICEITEM,
  PREDICTED_LINK_TO_INVOICEITEM_SUCCESS,
  PREDICTED_LINK_TO_INVOICEITEM_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  // Jobs List CRUD
  jobsData: [],
  jobsDataLoading: false,
  jobs: [],
  jobDelete: [],
  jobUpdate: [],
  // Jobs Status CRUD
  jobStatusData: [],

  jobStatus: [],
  jobStatusCreateSuccess: [],
  jobStatusDelete: [],
  jobStatusUpdate: [],

  jobPDFSinglePageData: [],

  jobTypeList: [],
  jobTypeCreateSuccess: [],
  jobTypeDelete: [],
  jobTypeUpdate: [],

  jobPriorityList: [],
  jobPriorityCreateSuccess: [],
  jobPriorityDelete: [],
  jobPriorityUpdate: [],

  singleCustomerJobsListData: [],
  uninvoicedJobsListData: [],
  jobConversionToInvoiceSuccess: [],
  convertJobToInvoiceLoading: false,
  loading: false,
  jobDeleteSuccess: [],
  jobUpdateSuccess: [],
  jobUpdateSuccessLoading: false,
  loadingSingleCustomerJobsListData: false,
  jobsCreateSuccess: [],
  jobsCreateSuccessLoading: false,
  recurringJobListData: [],
  recurringJobListDataLoading: false,
  recurringJobCreateSuccess: [],
  recurringJobCreateSuccessLoading: false,
  recurringJobDetails: [],
  recurringJobDetailsLoading: false,
  multipleJobFiles: [],
  multipleJobFilesLoading: false,
  singleJobFilesList: [],
  singleJobFilesListLoading: false,

  deleteSingleJobFileSuccess: [],
  deleteSingleJobFileLoading: false,

  updateFileAttachmentSuccess: [],
  updateFileAttachmentLoading: false,

  jobSearchListData: [],
  jobSearchListDataLoading: false,
  jobsOpenListData: [],
  jobsOpenListDataLoading: false,

  readyToInvoiceJobsListData: [],
  readyToInvoiceJobsListDataLoading: false,

  markJobAsCompletedSuccess: [],
  markJobAsCompletedSuccessLoading: false,
  markJobAsCompletedFail: [],

  convertJobToProformaInvoiceSuccess: [],
  convertJobToProformaInvoiceLoading: [],

  updateRecurringJobSuccess: [],
  updateRecurringJobSuccessLoading: false,

  convertJobToProformaInvoiceFail: [],

  invoicesByJob: [],
  invoicesByJobLoading: false,

  predictedMarkBilledSuccess: [],
  predictedMarkBilledLoading: false,
  predictedLinkToInvoiceItemSuccess: [],
  predictedLinkToInvoiceItemLoading: false,
};

const Jobs = (state = INIT_STATE, action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case GET_JOBS_DATA:
      return { ...state, jobsDataLoading: true };

    case GET_JOBS_DATA_SUCCESS:
      return {
        ...state,
        jobsData: action.payload,
        jobsDataLoading: false,
      };
    case GET_JOBS_DATA_FAIL:
      return {
        ...state,
        jobsData: [],
        jobsDataLoading: false,
      };
    // case JOB
    case ADD_NEW_JOB:
      return {
        ...state,
        jobsCreateSuccessLoading: true,
      };
    case ADD_JOB_SUCCESS:
      return {
        ...state,
        isJOBCreated: true,
        jobsCreateSuccess: action.payload,
        isJobsAdd: true,
        isJobsAddFail: false,
        jobsCreateSuccessLoading: false,
      };

    case ADD_JOB_FAIL:
      return {
        ...state,
        error: action.payload,
        isJobsAdd: false,
        isJobsAddFail: true,
        jobsCreateSuccessLoading: false,
      };
    case DELETE_JOB_SUCCESS:
      return {
        ...state,
        jobDeleteSuccess: action.payload,
      };
    case DELETE_JOB_FAIL:
      return {
        ...state,
        error: action.payload,
        isJobDeleted: false,
        isJobDeletedFail: true,
      };
    case UPDATE_JOB:
      return {
        ...state,
        jobUpdateSuccessLoading: true,
      };
    case UPDATE_JOB_SUCCESS:
      return {
        ...state,
        jobUpdateSuccess: action.payload,
        jobUpdateSuccessLoading: false,
      };
    case UPDATE_JOB_FAIL:
      return {
        ...state,
        jobUpdateSuccess: action.payload,
        jobUpdateSuccessLoading: false,
      };
    // Jobs Status
    case GET_JOB_STATUS_DATA:
      return { ...state, loading: true };

    case GET_JOB_STATUS_DATA_SUCCESS:
      return {
        ...state,
        jobStatusData: action.payload,
      };
    case GET_JOB_STATUS_DATA_FAIL:
      return {
        ...state,
        jobStatusData: [],
      };
    case ADD_JOB_STATUS_SUCCESS:
      return {
        ...state,
        jobStatusCreateSuccess: action.payload,
      };

    case ADD_JOB_STATUS_FAIL:
      return {
        ...state,
        error: action.payload,
        isJobStatusAdd: false,
        isJobStatusAddFail: true,
      };

    case DELETE_JOB_STATUS: {
      return {
        ...state,
      };
    }
    case DELETE_JOB_STATUS_SUCCESS:
      return {
        ...state,
        jobStatusDelete: action.payload,
        isJobStatusDeleted: true,
        isJobStatusDeletedFail: false,
      };
    case DELETE_JOB_STATUS_FAIL:
      return {
        ...state,
        error: action.payload,
        isJobStatusDeleted: false,
        isJobStatusDeletedFail: true,
      };
    case UPDATE_JOB_STATUS_SUCCESS:
      return {
        ...state,
        jobStatusUpdate: action.payload,
        isJobStatusUpdated: true,
        isJobStatusUpdatedFail: false,
      };
    case UPDATE_JOB_STATUS_FAIL:
      return {
        ...state,
        error: action.payload,
        isJobStatusUpdated: false,
        isJobStatusUpdatedFail: true,
      };
    case GET_JOBS_PDF_DATA:
      return { ...state, loading: true };

    case GET_JOBS_PDF_DATA_SUCCESS:
      return {
        ...state,
        jobPDFSinglePageData: action.payload,
      };
    case GET_JOBS_PDF_DATA_FAIL:
      return {
        ...state,
        jobPDFSinglePageData: [],
      };
    case GET_JOBS_TYPE_DATA:
      return { ...state, loading: true };

    case GET_JOBS_TYPE_DATA_SUCCESS:
      return {
        ...state,
        jobTypeList: action.payload,
      };
    case GET_JOBS_TYPE_DATA_FAIL:
      return {
        ...state,
        jobTypeList: [],
      };

    case ADD_JOB_TYPE:
      return {
        ...state,
      };
    case ADD_JOB_TYPE_SUCCESS:
      return {
        ...state,
        jobTypeCreateSuccess: action.payload,
      };
    case ADD_JOB_TYPE_FAIL:
      return {
        ...state,
        jobTypeCreateSuccess: action.payload,
      };

    case DELETE_JOB_TYPE:
      return {
        ...state,
      };

    case DELETE_JOB_TYPE_SUCCESS:
      return {
        ...state,
        jobTypeDelete: action.payload,
      };

    case DELETE_JOB_TYPE_FAIL:
      return {
        ...state,
        jobTypeDelete: action.payload,
      };

    case UPDATE_JOB_TYPE:
      return {
        ...state,
      };

    case UPDATE_JOB_TYPE_SUCCESS:
      return {
        ...state,
        jobTypeUpdate: action.payload,
      };

    case UPDATE_JOB_TYPE_FAIL:
      return {
        ...state,
        jobTypeUpdate: action.payload,
      };

    case GET_JOBS_PRIORITY_DATA:
      return { ...state, loading: true };

    case GET_JOBS_PRIORITY_DATA_SUCCESS:
      return {
        ...state,
        jobPriorityList: action.payload,
      };
    case GET_JOBS_PRIORITY_DATA_FAIL:
      return {
        ...state,
        jobPriorityList: [],
      };

    case ADD_JOB_PRIORITY:
      return {
        ...state,
      };

    case ADD_JOB_PRIORITY_SUCCESS:
      return {
        ...state,
        jobPriorityCreateSuccess: action.payload,
      };

    case ADD_JOB_PRIORITY_FAIL:
      return {
        ...state,
        jobPriorityCreateSuccess: action.payload,
      };

    case DELETE_JOB_PRIORITY:
      return {
        ...state,
      };

    case DELETE_JOB_PRIORITY_SUCCESS:
      return {
        ...state,
        jobPriorityDelete: action.payload,
      };

    case DELETE_JOB_PRIORITY_FAIL:
      return {
        ...state,
        jobPriorityDelete: action.payload,
      };

    case UPDATE_JOB_PRIORITY:
      return {
        ...state,
      };

    case UPDATE_JOB_PRIORITY_SUCCESS:
      return {
        ...state,
        jobPriorityUpdate: action.payload,
      };

    case UPDATE_JOB_PRIORITY_FAIL:
      return {
        ...state,
        jobPriorityUpdate: action.payload,
      };

    case GET_SINGLE_CUSTOMER_JOBS_LIST_DATA:
      return { ...state, loadingSingleCustomerJobsListData: true };

    case GET_SINGLE_CUSTOMER_JOBS_LIST_DATA_SUCCESS:
      return {
        ...state,
        singleCustomerJobsListData: action.payload,
        loadingSingleCustomerJobsListData: false,
      };
    case GET_SINGLE_CUSTOMER_JOBS_LIST_DATA_FAIL:
      return {
        ...state,
        loadingSingleCustomerJobsListData: false,
      };
    case GET_UNINVOICED_JOBS_LIST_DATA:
      return { ...state, loading: true };

    case GET_UNINVOICED_JOBS_LIST_DATA_SUCCESS:
      return {
        ...state,
        uninvoicedJobsListData: action.payload,
        loading: false,
      };
    case GET_UNINVOICED_JOBS_LIST_DATA_FAIL:
      return {
        ...state,
      };
    case CONVERT_JOB_TO_INVOICE:
      return { ...state, loading: true, convertJobToInvoiceLoading: true };

    case CONVERT_JOB_TO_INVOICE_SUCCESS:
      return {
        ...state,
        jobConversionToInvoiceSuccess: action.payload,
        loading: false,
        convertJobToInvoiceLoading: false,
      };
    case CONVERT_JOB_TO_INVOICE_FAIL:
      return {
        ...state,
        loading: false,
        convertJobToInvoiceLoading: false,
      };
    case GET_RECURRING_JOBS_LIST_DATA:
      return { ...state, recurringJobListDataLoading: true };

    case GET_RECURRING_JOBS_LIST_DATA_SUCCESS:
      return {
        ...state,
        recurringJobListData: action.payload,
        recurringJobListDataLoading: false,
      };
    case GET_RECURRING_JOBS_LIST_DATA_FAIL:
      return {
        ...state,
        recurringJobListDataLoading: false,
      };

    case CREATE_RECURRING_JOB:
      return { ...state, recurringJobCreateSuccessLoading: true };

    case CREATE_RECURRING_JOB_SUCCESS:
      return {
        ...state,
        createRecurringJobSuccess: action.payload,
        recurringJobCreateSuccessLoading: false,
      };

    case CREATE_RECURRING_JOB_FAIL:
      return {
        ...state,
        recurringJobCreateSuccessLoading: false,
      };
    case GET_RECURRING_JOB_DETAILS:
      return { ...state, loading: true };

    case GET_RECURRING_JOB_DETAILS_SUCCESS:
      return {
        ...state,
        recurringJobDetails: action.payload,
      };
    case GET_RECURRING_JOB_DETAILS_FAIL:
      return {
        ...state,
      };
    case UPDATE_RECURRING_JOB:
      return {
        ...state,
        updateRecurringJobSuccess: action.payload,
        updateRecurringJobSuccessLoading: true,
      };

    case UPDATE_RECURRING_JOB_SUCCESS:
      return {
        ...state,
        updateRecurringJobSuccess: action.payload,
        updateRecurringJobSuccessLoading: false,
      };

    case UPDATE_RECURRING_JOB_FAIL:
      return {
        ...state,
        updateRecurringJobSuccess: action.payload,
        updateRecurringJobSuccessLoading: false,
      };
    case UPLOAD_JOB_FILES:
      return {
        ...state,
        multipleJobFilesLoading: true,
      };
    case UPLOAD_JOB_FILES_SUCCESS:
      return {
        ...state,
        multipleJobFiles: action.payload,
        multipleJobFilesLoading: false,
      };
    case UPLOAD_JOB_FILES_FAIL:
      return {
        ...state,
        multipleJobFiles: action.payload,
        multipleJobFilesLoading: false,
      };
    case SEARCH_SINGLE_JOB_FILES_LIST:
      return {
        ...state,
        singleJobFilesListLoading: true,
      };
    case SEARCH_SINGLE_JOB_FILES_LIST_SUCCESS:
      return {
        ...state,
        singleJobFilesList: action.payload,
        singleJobFilesListLoading: false,
      };
    case SEARCH_SINGLE_JOB_FILES_LIST_FAIL:
      return {
        ...state,
        singleJobFilesList: action.payload,
        singleJobFilesListLoading: false,
      };
    case DELETE_SINGLE_JOB_FILE:
      return {
        ...state,
        deleteSingleJobFileLoading: true,
      };
    case DELETE_SINGLE_JOB_FILE_SUCCESS:
      return {
        ...state,
        deleteSingleJobFileSuccess: action.payload,
        deleteSingleJobFileLoading: false,
      };
    case DELETE_SINGLE_JOB_FILE_FAIL:
      return {
        ...state,
        deleteSingleJobFileSuccess: action.payload,
        deleteSingleJobFileLoading: false,
      };
    case UPDATE_FILE_ATTACHMENT:
      return {
        ...state,
        updateFileAttachmentLoading: true,
      };
    case UPDATE_FILE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        updateFileAttachmentSuccess: action.payload,
        updateFileAttachmentLoading: false,
      };
    case UPDATE_FILE_ATTACHMENT_FAIL:
      return {
        ...state,
        updateFileAttachmentSuccess: action.payload,
        updateFileAttachmentLoading: false,
      };
    case GET_JOB_SEARCH_LIST_DATA:
      return { ...state, jobSearchListDataLoading: true };

    case GET_JOB_SEARCH_LIST_DATA_SUCCESS:
      return {
        ...state,
        jobSearchListData: action.payload,
        jobSearchListDataLoading: false,
      };
    case GET_JOB_SEARCH_LIST_DATA_FAIL:
      return {
        ...state,
        jobSearchListData: action.payload,
        jobSearchListDataLoading: false,
      };
    case GET_JOBS_OPEN_LIST_DATA:
      return { ...state, jobsOpenListDataLoading: true };

    case GET_JOBS_OPEN_LIST_DATA_SUCCESS:
      return {
        ...state,
        jobsOpenListData: action.payload,
        jobsOpenListDataLoading: false,
      };
    case GET_JOBS_OPEN_LIST_DATA_FAIL:
      return {
        ...state,
        jobsOpenListData: action.payload,
        jobsOpenListDataLoading: false,
      };
    case GET_READY_TO_INVOICE_JOBS_LIST_DATA:
      return { ...state, readyToInvoiceJobsListDataLoading: true };
    case GET_READY_TO_INVOICE_JOBS_LIST_DATA_SUCCESS:
      return {
        ...state,
        readyToInvoiceJobsListData: action.payload,
        readyToInvoiceJobsListDataLoading: false,
      };
    case GET_READY_TO_INVOICE_JOBS_LIST_DATA_FAIL:
      return {
        ...state,
        readyToInvoiceJobsListData: action.payload,
        readyToInvoiceJobsListDataLoading: false,
      };
    case MARK_JOB_AS_COMPLETED:
      return { ...state, markJobAsCompletedSuccessLoading: true };
    case MARK_JOB_AS_COMPLETED_SUCCESS:
      return {
        ...state,
        markJobAsCompletedSuccess: action.payload,
        markJobAsCompletedSuccessLoading: false,
      };
    case MARK_JOB_AS_COMPLETED_FAIL:
      return {
        ...state,
        markJobAsCompletedFail: action.payload,
        markJobAsCompletedSuccessLoading: false,
      };
    case CONVERT_JOB_TO_PROFORMA_INVOICE:
      return { ...state, convertJobToProformaInvoiceLoading: true };

    case CONVERT_JOB_TO_PROFORMA_INVOICE_SUCCESS:
      return {
        ...state,
        convertJobToProformaInvoiceSuccess: action.payload,
        convertJobToProformaInvoiceLoading: false,
      };
    case CONVERT_JOB_TO_PROFORMA_INVOICE_FAIL:
      return {
        ...state,
        convertJobToProformaInvoiceFail: action.payload,
        convertJobToProformaInvoiceLoading: false,
      };

    case GET_INVOICES_BY_JOB:
      return { ...state, invoicesByJobLoading: true };

    case GET_INVOICES_BY_JOB_SUCCESS:
      return {
        ...state,
        invoicesByJob: action.payload,
        invoicesByJobLoading: false,
      };

    case GET_INVOICES_BY_JOB_FAIL:
      return {
        ...state,
        invoicesByJobLoading: false,
      };

    case PREDICTED_MARK_BILLED:
      return { ...state, predictedMarkBilledLoading: true };
    case PREDICTED_MARK_BILLED_SUCCESS:
      return {
        ...state,
        predictedMarkBilledSuccess: action.payload,
        predictedMarkBilledLoading: false,
      };
    case PREDICTED_MARK_BILLED_FAIL:
      return { ...state, predictedMarkBilledLoading: false };

    case PREDICTED_LINK_TO_INVOICEITEM:
      return { ...state, predictedLinkToInvoiceItemLoading: true };
    case PREDICTED_LINK_TO_INVOICEITEM_SUCCESS:
      return {
        ...state,
        predictedLinkToInvoiceItemSuccess: action.payload,
        predictedLinkToInvoiceItemLoading: false,
      };
    case PREDICTED_LINK_TO_INVOICEITEM_FAIL:
      return { ...state, predictedLinkToInvoiceItemLoading: false };

    default:
      return { ...state };
  }
};

export default Jobs;
